export default __webpack_public_path__ + "static/media/help-rav-qa-1.a9496a68.png";